import Swal from "sweetalert2";
import {responses} from "@/services/responses";
window.gateway = `https://lna.abc.co.zm/KazangPaymentGateway/`
// window.gateway = `http://192.168.1.175:8082/KazangPaymentGateway/`

window.responses = responses;
window.Swal = Swal;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;